export default __webpack_public_path__ + "static/media/VA.08ac26db.svg";